(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bagby-collection-intro"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('[data-bagby-collection-desc-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var wrap = button.closest('.bagby-collection-intro__container').querySelector('[data-bagby-collection-desc]');
        var expanded = wrap.getAttribute('data-expanded') === 'true';
        wrap.setAttribute('data-expanded', String(!expanded));
        button.setAttribute('aria-expanded', String(!expanded));
        button.textContent = expanded
          ? button.getAttribute('data-read-more-label')
          : button.getAttribute('data-read-less-label');
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
